import { render, staticRenderFns } from "./page-documents-edit.vue?vue&type=template&id=74efe834"
import script from "./page-documents-edit.vue?vue&type=script&lang=ts"
export * from "./page-documents-edit.vue?vue&type=script&lang=ts"
import style0 from "./page-documents-edit.vue?vue&type=style&index=0&id=74efe834&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports